export { default } from "./PowerWordLiteLockVeil";
